import { Request } from '../utils';

const prefix = 'order';

/* GET End User List */
export const getOrdersList = queries => {
  const {
    limit,
    skip,
    orderBy,
    sortBy,
    name,
    surname,
    telephone,
    min_order_date,
    max_order_date,
    order_statuses,
    pharmacy_name,
    order_no
  } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!surname && params.append('surname', surname);
  !!telephone && params.append('telephone', telephone);
  !!min_order_date && params.append('min_order_date', min_order_date);
  !!max_order_date && params.append('max_order_date', max_order_date);
  !!order_statuses[0] && params.append('order_statuses[0]', order_statuses[0]);
  !!pharmacy_name && params.append('pharmacy_name', pharmacy_name);
  !!order_no && params.append('order_no', order_no);

  return Request.get(`${prefix}`, { params, onlyError: true });
};

/* GET Order Detail */
export const getOrderDetail = orderId => {
  return Request.get(`${prefix}/${orderId}`, { onlyError: true });
};
